
import { useState, useEffect } from "react";
import { useToast } from "@/hooks/use-toast";
import { checkSupabaseConnection } from "@/lib/supabase";

export const useConnectionStatus = () => {
  const { toast } = useToast();
  const [connectionStatus, setConnectionStatus] = useState<boolean | null>(null);

  useEffect(() => {
    const checkConnection = async () => {
      const isConnected = await checkSupabaseConnection();
      setConnectionStatus(isConnected);
      if (!isConnected) {
        toast({
          title: "Connection Issue",
          description: "Having trouble connecting to the server. Your data will be saved locally.",
          variant: "destructive"
        });
      }
    };
    
    checkConnection();
  }, [toast]);

  return connectionStatus;
};
